<template>
  <div>
    <image-recorder
      :show="show && !imageId"
      @close="$emit('close')"
      @image="handleImageUploaded"
    />
    <div
      v-if="imageId"
      class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50"
      @click.self="handleClose"
    >
      <div class="bg-white rounded-2xl p-6 w-[90%] max-w-md shadow-xl">
        <div class="flex justify-between items-center mb-4">
          <h2 class="text-lg font-bold text-blue">{{ $t("orders.ticket") }}</h2>
          <button
            class="p-2 rounded-full hover:bg-gray-100 transition"
            @click="handleClose"
          >
            <c-icon name="CloseRound" size="1.2rem" class="text-gray-400" />
          </button>
        </div>
        <div v-if="parsedTicket">
          <div class="text-base max-h-[50vh] overflow-y-auto mb-4">
            <div
              v-for="(item, index) in parsedTicket.items"
              :key="index"
              class="flex justify-between py-2 border-b border-gray-100"
            >
              <span class="text-gray-600">
                {{ item.quantity }}x {{ item.name }}
              </span>
              <span class="font-medium text-blue">
                {{ $filters.currency(item.price) }}
              </span>
            </div>
          </div>
          <div
            class="flex justify-between py-4 border-t border-gray-300"
          >
            <span class="font-bold text-lg text-blue">{{ $t("orders.total") }}:</span>
            <span class="font-bold text-lg" :style="{ color: accentColor }">
              {{ $filters.currency(parsedTicket.totalAmount) }}
            </span>
          </div>
          <div
            class="flex flex-row items-center justify-center space-x-4 mt-4"
            :class="{ 'opacity-50 pointer-events-none': loading }"
          >
            <button
              class="px-6 py-3 rounded-xl font-semibold border transition hover:opacity-90"
              :style="{ borderColor: accentColor, color: accentColor }"
              @click="handleCancel"
            >
              {{ $t("cancel") }}
            </button>
            <button
              class="px-6 py-3 rounded-xl text-white font-semibold transition hover:opacity-90"
              :style="{ backgroundColor: accentColor }"
              @click="handleConfirm"
            >
              {{ $t("accept") }}
            </button>
          </div>
        </div>
        <div
          v-else
          class="flex flex-col items-center justify-center py-10"
        >
          <c-loading-spinner />
          <p class="text-gray-400 mt-4">{{ $t("orders.analyzing-ticket") }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ImageRecorder from "./ImageRecorder.vue";
import CIcon from "../../../core-ui/src/components/CIcon.vue";
import CLoadingSpinner from "../../../core-ui/src/components/CLoadingSpinner.vue";
import api from "@/api";
import { mapState } from "pinia";
import { authStore } from "@/stores/auth";

export default {
  name: "AddOrderTicket",
  components: {
    ImageRecorder,
    CIcon,
    CLoadingSpinner,
  },
  data() {
    return {
      parsedTicket: null,
      imageId: null,
      loading: false,
      show: false,
    };
  },
  props: {
    customerId: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapState(authStore, ["branding"]),
    accentColor() {
      return this.branding?.accentColor || "#6B9AE1";
    },
  },
  mounted() {
    this.show = true;
  },
  methods: {
    handleCancel() {
      this.parsedTicket = null;
      this.imageId = null;
    },
    handleClose() {
      this.parsedTicket = null;
      this.imageId = null;
      this.$emit("close");
    },
    async handleConfirm() {
      this.loading = true;
      try {
        await api.post(`/customer/${this.customerId}/orderTicket`, {
          parsedTicket: this.parsedTicket,
          imageId: this.imageId,
        });
        this.$emit("order-added");
        this.$emit("close");
      } catch (error) {
        console.error("Error adding order:", error);
      } finally {
        this.loading = false;
        this.parsedTicket = null;
        this.imageId = null;
      }
    },
    async handleImageUploaded(imageId) {
      this.loading = true;
      this.imageId = imageId;
      try {
        const result = await api.post(`/customer/${this.customerId}/scanTicket`, {
          imageId,
        });
        this.parsedTicket = result.data;
      } catch (error) {
        if (error.response && error.response.status === 400) {
          this.$notificationGenerator.error(this.$t("orders.ticket-image-not-valid"));
          this.parsedTicket = null;
          this.imageId = null;
        }
      }
      this.loading = false;
    },
  },
};
</script>

<style scoped></style>
